// extracted by mini-css-extract-plugin
module.exports = {"container":"PreviewContainer_container__23UEb","textCenter":"PreviewContainer_textCenter__3ccqf"};